import React, { Component } from 'react';
import {
    getDepositSummary as fetchAchSummary,
    fetchUrl
} from './depositSummaryActions';
import {
    getDepositSummary,
    getCount,
    getPages,
    getDepositSummaryErrorMessage,
    getIsDepositSummaryLoading
} from './depositSummaryEntity';
import DepositBatchSummary from './DepositBatchSummary/DepositBatchSummary';
import DepositSummaryListItem from './DepositSummaryListItem/DepositSummaryListItem';
import ColorDollarAmountCell from '../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import AmountFilter from '../Table/Filters/AmountFilter/AmountFilter';
import {
    transformEllipsisNumberCell,
    transformCurrencyCodeCell,
    transformDateCellNoTimeZone
} from '../../utils/cell';
import Table from '../Table/Table';
import CurrencyCodeFilter from '../Table/Filters/CurrencyCodeFilter/CurrencyCodeFilter';
import { getCurrencyCode } from '@nexio/emvio-util-app';
import { connect } from 'react-redux';
import InPageMerchantSelector from '../MerchantSelector/InPageMerchantSelector';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { getSelf } from '../Self/selfEntity';

const defaultColumnsAndProps = [
    {
        accessor: 'merchantName',
        className: ['cursor-pointer'],
        filterable: false,
        label: 'Merchant',
        minWidth: 150,
        show: true,
        sortable: false
    },
    {
        accessor: 'date',
        Cell: transformDateCellNoTimeZone,
        className: ['cursor-pointer'],
        defaultSortDesc: true,
        filterable: false,
        label: 'Date',
        minWidth: 100,
        show: true
    },
    {
        accessor: 'dda',
        transformData: transformEllipsisNumberCell,
        className: ['cursor-pointer'],
        label: 'DDA',
        minWidth: 70,
        show: true
    },
    {
        accessor: 'amount',
        Cell: (props) => <ColorDollarAmountCell amount={props.value} currencyCode={getCurrencyCode(props.original.currencyId)} />,
        className: ['right-justify', 'cursor-pointer'],
        Filter: ({ filter, onChange }) => (<AmountFilter filter={filter} onChange={onChange} />),
        label: 'Amount',
        minWidth: 100,
        show: true
    },
    {
        accessor: 'currencyId',
        transformData: transformCurrencyCodeCell,
        className: ['cursor-pointer'],
        Filter: ({ filter, onChange }) => (<CurrencyCodeFilter filter={filter} onChange={onChange} />),
        label: 'Currency',
        minWidth: 110,
        show: false
    },
    {
        accessor: 'merchantId',
        className: ['cursor-pointer'],
        excelStringField: true,
        filterable: false,
        label: 'Merchant ID',
        minWidth: 145,
        show: false
    }
];

export class DepositSummary extends Component {
    render() {
        const dateKey = 'date';

        return (
            <>
                {this.props.flags?.resellerPhase1 && this.props.self?.accountType === 'RESELLER' && <InPageMerchantSelector />}
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-deposit-summary-table"
                    clickShouldExpandRow
                    dateKey={dateKey}
                    defaultColumnsAndProps={defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: dateKey
                    }]}
                    hasNoCount={true}
                    fetchData={fetchAchSummary}
                    countSelector={getCount}
                    dataSelector={getDepositSummary}
                    errorMessageSelector={getDepositSummaryErrorMessage}
                    isDataLoadingSelector={getIsDepositSummaryLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    ListItemComponent={DepositSummaryListItem}
                    noDataText="No Deposit Summaries Found"
                    shouldUseGlobalDate
                    SubComponent={DepositBatchSummary}
                    uniqueTableName="DepositSummary"
                    filterable={true}
                    /* eslint-disable-next-line @stylistic/max-len */
                    footerText="The amounts presented may be different than what was authorized, as the funds may not have settled. Amounts being processed may differ temporarily from batch totals if they experience a temporary risk hold; common reasons include large single transactions, unusual activity, or unexpected volume increases. Please check the batch details in a few days once it's finalized."
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        self: getSelf(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default withLDConsumer()(connect(mapStateToProps, mapDispatchToProps)(DepositSummary));